import { Theme } from "model/Theme";
import { MatchesTab } from "../MatchesTab";
import { selectTourMatchIds } from "selectors/Tour";
import { useAppSelector } from "app/hooks";

interface Props {
  tourId: string;
  theme: Theme | undefined;
}

export const TourMatchesTab = ({ tourId, theme }: Props) => {
  const matchIds =
    useAppSelector((state) => selectTourMatchIds(state, tourId)) ?? [];

  return <MatchesTab matchIds={matchIds} theme={theme} />;
};
